((function(){

    const adevDebounce = (func, delay) => {
        let timeout;
        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    }

    document.querySelectorAll('[data-adev-collections-search="wrap"]:not(.adev-init)').forEach(function(el) {
        const itemsEl = el.querySelector('[data-adev-collections-search="items"]');
        const buttonEl = el.querySelector('[data-adev-collections-search="button"]');
        const inputEl = el.querySelector('[data-adev-collections-search="input"]');

        const debouncedSearch = adevDebounce(function(query) {
            fetch(`/search/suggest?q=${query}&section_id=adev-collections-search-result`, {
                method: 'GET',
            })
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                }

                return response.text();
            })
            .then(data => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const resultsMarkup = doc.querySelector('#shopify-section-adev-collections-search-result');

                if (!resultsMarkup) return;

                itemsEl.innerHTML = resultsMarkup.innerHTML;
                buttonEl.classList.remove('adev-loading');
            })
            .catch((error) => {
                console.error('Error:', error);
                buttonEl.classList.remove('adev-loading');
            });


        }, 300);

        inputEl.addEventListener('input', function(event) {
            const query = event.target.value;
            buttonEl.classList.add('adev-loading');

            itemsEl.innerHTML = '';

            debouncedSearch(query);
        });

        el.classList.add('adev-init');
    });

})());